import React from 'react';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ChevronUpRegularIcon(props) {
  return <FontAwesomeIcon icon={faChevronUp} {...props} />;
}
